module.exports = __webpack_public_path__ + "img/ssWells_visual.30fd8acf.jpg";